import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";

function InternalComplaintsCommittee() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  document.title = "Internal Complaints Committee | PSG-IAP"
  const dispatch = useDispatch();
  const statutorySubpage = useSelector(
    (state) => state.StatutoryCommitteeReducer.StatutoryCommitteeSubpage
  );

  useEffect(() => {
   if (!statutorySubpage?.length) {
     dispatch({ type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE });
   }
 }, []); 

  // Fetch Internal Complaints Committee data
  const committeeData = statutorySubpage?.find(
    (item) => item.map_name === "Internal Complaints Committee"
  );

  if (!committeeData) {
    return (
      <div className="text-center mt-5 text-muted">
        Loading Internal Complaints Committee...
      </div>
    );
  }

  const departments = committeeData?.departments || [];

  return (
    <div>
      {/* Header */}
     
      <Header />
        <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
         thirdLevelName="Internal CompilanceCommittee"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <Header />

      {/* Page Content */}
      <div className="statutory">
        <div className="container committee-container">
          <h6 className="rectangle-title mb-0 me-3 position-relative">
            <span className="rectangle-marker me-2"></span>
            {committeeData.committee_name}
          </h6>
          <hr />

        {/* Dynamic Committee Content */}
             {committeeData?.content ? (
             <div className="mt-4 rect-text rect-bullet"
               style={{
               textAlign: "justify",
               fontSize: "16px",
                width:  "unset" ,
                lineHeight: "4",
               color: "#333",
               marginBottom: "20px",
               fontFamily: "Poppins, sans-serif",
      
                 }} >
           
                <div
                  className="rect-bullet subb-title container-fluid px-3 py-2 responsive-content"
                   dangerouslySetInnerHTML={{ __html: committeeData.content }}
             />
            </div>
           ) : (
           <p className="text-center mt-4 text-muted">No content available.</p>
      
           )}

          {/* Departments & Members */}
          {departments.map((dept, deptIdx) => (
            <div key={deptIdx} className="mb-5">
              <h5 className="mt-4 text-start subb-title">
                {dept.department_name}
              </h5>
              <div className="row mt-3">
                {dept.members.map((member, idx) => (
                   <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
                    <div className="card member-card text-left p-4 shadow-sm">
                      <h5 className="member-name">{member.member_name}</h5>
                      {member.designation && (
                        <p className="member-title">{member.designation}</p>
                      )}
                      {member.committee && (
                        <p className="member-role">{member.committee}</p>
                      )}
                      {member.phone && (
                        <p className="member-text">
                          <span className="label-blue">Mobile No:</span>{" "}
                          <span className="value-grey">{member.phone}</span>
                        </p>
                      )}
                      {member.email && (
                        <p className="member-text">
                          <span className="label-blue">E-mail:</span>{" "}
                          <span className="value-grey">{member.email}</span>
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Sidebar */}
      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default InternalComplaintsCommittee;
